import { Button } from "antd";
import { useDispatch } from "react-redux";
import { PrintQrCode } from "../../../redux/actions/qrCodes/qrCodes-action";
import Alertify from "../../../services/alertify";

const PrintSingleQrCode = ({ ppfRollNumber, size = 150 }) => {
  const dispatch = useDispatch();

  const handlePrintQrCode = () => {
    console.log(ppfRollNumber);
    dispatch(PrintQrCode({ ppfRollNumber, size }))
      .then((response) => {
        console.log("QR Code Response:", response);

        if (response?.payload?.data) {
          try {
            // Create a new Blob with the correct MIME type
            const blob = new Blob([response.payload.data], {
              type: "image/png",
            });
            console.log("Created blob:", blob);
            const blobUrl = URL.createObjectURL(blob);
            console.log("Blob URL created:", blobUrl);
            // Open a new window for printing
            const printWindow = window.open("", "_blank");
            if (printWindow) {
              printWindow.document.write(`
                <html>
                  <head>
                    <title>Print QR Code</title>
                    <style>
                      @media print {
                        body { margin: 0; padding: 0; }
                        .no-print { display: none; }
                        .print-only { display: block; }
                        .container { padding: 0; text-align: left; }
                        img { 
                          margin: 0;
                          border: none;
                        }
                        h2 { display: none; }
                      }
                      @media screen {
                        .print-only { display: none; }
                      }
                      body { 
                        margin: 0; 
                        font-family: Arial, sans-serif;
                      }
                      .container { 
                        text-align: center;
                        padding: 20px;
                      }
                      .print-container {
                        position: absolute;
                        top: 0;
                        left: 0;
                      }
                      img { 
                        display: block;
                        width: ${size}px; 
                        margin: 20px auto;
                        border: 1px solid #eee;
                      }
                      h2 { margin-bottom: 20px; }
                      .buttons {
                        margin-top: 20px;
                      }
                      button {
                        padding: 8px 16px;
                        background: #1890ff;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                        margin: 0 5px;
                      }
                      .download-note {
                        margin-top: 15px;
                        font-size: 14px;
                        color: #666;
                      }
                    </style>
                  </head>
                  <body>
                    <!-- Print-only version (QR code only in top left) -->
                    <div class="print-only print-container">
                      <img src="${blobUrl}" alt="QR Code" style="margin-bottom:0" />
                    </div>
                    
                    <!-- Screen version (with all controls and information) -->
                    <div class="container no-print">
                      <h2>QR Code for Roll Number: ${ppfRollNumber}</h2>
                      <img src="${blobUrl}" alt="QR Code" />
                      <div class="buttons">
                        <button onclick="window.print()">Print</button>
                        <button onclick="downloadImage()">Download</button>
                        <button onclick="window.close()">Close</button>
                      </div>
                      <p class="download-note">
                        If your printer is not connected, you can download the QR code image.
                      </p>
                    </div>
                    <script>
                      // Auto-print when the page loads
                      window.onload = function() {
                        // Small delay to ensure image is loaded
                        setTimeout(() => {
                          window.print();
                        }, 1000);
                      };
                      
                      // Function to download the image
                      function downloadImage() {
                        const link = document.createElement('a');
                        link.href = "${blobUrl}";
                        link.download = "QR_Code_${ppfRollNumber}.png";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }
                    </script>
                  </body>
                </html>
              `);
              printWindow.document.close();

              // Clean up the blob URL after a delay
              setTimeout(() => URL.revokeObjectURL(blobUrl), 60000); // Longer timeout to allow for download
            } else {
              // Fallback for popup blocked: Direct download
              const link = document.createElement("a");
              link.href = blobUrl;
              link.download = `QR_Code_${ppfRollNumber}.png`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);

              Alertify.success("QR Code downloaded (popup was blocked)");
            }

            Alertify.success("QR Code ready for printing or download");
          } catch (error) {
            console.error("Error processing blob:", error);
            Alertify.error("Error processing QR code image");
          }
        } else {
          Alertify.error("Failed to generate QR code");
        }
      })
      .catch((error) => {
        console.error("Error generating QR code:", error);
        Alertify.error("Error generating QR code");
      });
  };

  return (
    <Button type="primary" className="rounded-md" onClick={handlePrintQrCode}>
      Print
    </Button>
  );
};

export default PrintSingleQrCode;
